import { Button } from "@radix-ui/themes";
import { BrainIcon } from "lucide-react";
import { Source } from "@/v2/components/messageSources";

export function ChainOfThoughtsButton({
  source,
  onClick,
}: {
  source?: Source;
  onClick: () => void;
}) {
  if (!source?.chainOfThoughtSteps || source.chainOfThoughtSteps.length === 0) {
    return null;
  }

  return (
    <Button
      size={"1"}
      color={"gray"}
      variant={"outline"}
      highContrast
      style={{
        boxShadow: "var(--shadow-3)",
      }}
      onClick={onClick}
    >
      <BrainIcon size={14} /> Chain of Thought
    </Button>
  );
}
